import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FieldIcon from "../../../utils/Register/field_icon";
import SendBtn from "../../../utils/Register/send_btn";
import conversion from "../../../assets/wito.png";
import backImage from "../../../assets/fondo.png";
import { FaEnvelope } from "react-icons/fa";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://server-postgre.vercel.app/api/password/verify-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Correo no encontrado");
      }

      navigate("/recover-password", { state: { email } }); // Navegar y pasar el email
    } catch (error) {
      setError("Error: " + error.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div
        className="flex flex-col items-center bg-cover bg-center rounded-xl"
        style={{
          backgroundImage: `url(${backImage})`,
          maxWidth: "420px",
          padding: "0 5%",
          backgroundClip: "padding-box",
        }}
      >
        <div className="text-center text-white mb-8 mt-12">
          <div className="flex justify-center mt-2">
            <img src={conversion} alt="Conversión" className="h-8" />
          </div>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-lg w-96">
          <h2 className="text-2xl font-bold text-center mb-6">
            Recuperar contraseña
          </h2>
          <form onSubmit={handleSubmit}>
            <FieldIcon
              type="email"
              placeholder="Ingresa tu correo"
              icon={<FaEnvelope />}
              label="Correo"
              id="email"
              name="email"
              autoComplete="email"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
            />

            <SendBtn
              label="Verificar"
              type="submit"
              style={{ backgroundColor: "#E5960E" }}
            />
            {error && <p className="text-red-500 text-center mt-2">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
